module.exports = __webpack_public_path__ + "assets/img/explain.045b83ad.png";